
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[dir1]",
      function () {
        return require("private-next-pages/[dir1]/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[dir1]"])
      });
    }
  